import { useState } from 'react';
import { GlobalProvider } from './context/GlobalProvider';

import { BMToken } from './portlet/Token';
import ResourceEnvironment from './portlet/ResourceEnvironment';
import DeviceDetailsManager from './DeviceDetailsManager/DeviceDetailsManager';
import AnalyticsScript from './Utils/AnalyticsScript';

function App() {
    const [env, setEnv] = useState(false);
    const [bmToken, setBMToken] = useState(false);

    return (
        <GlobalProvider>
            <ResourceEnvironment setEnv={setEnv} />
            <BMToken setBMToken={setBMToken} />
            {env && bmToken && (
                <>
                    {window.location.origin.includes("localhost") && <AnalyticsScript />}
                    <DeviceDetailsManager />
                </>
            )}
        </GlobalProvider>
    );
}

export default App;